<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: eraser</title>
  <g fill-rule="evenodd">
    <rect x="8" y="22" width="15" height="2" />

    <path
      d="M12,2
        Q14,0 16,2
        L22,8
        Q24,10 22,12
        L13,22
        Q12,23 11,23
        L8,23
        Q7,23 6,22
        L2,18
        Q0,16 2,14
        M3.5,16
        L9.2,9.7
        L15.5,15.5
        L10.5,21
        Q9.5,22 8.5,21
        Z"
    />
  </g>
</Icon>
